import React from "react";

export default function AnnotationLayer({ annotations = [] }) {
  return (
    <div className="annotation-layer" style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
      {annotations.map((ann) => (
        <div
          key={ann.id}
          title={ann.body}
          style={{
            position: "absolute",
            left: ann.x,
            top: ann.y,
            width: ann.width || 12,
            height: ann.height || 12,
            background: ann.visibility === "shared" ? "rgba(0,128,255,0.4)" : "rgba(128,128,128,0.4)",
            border: "1px solid #0b6",
          }}
        />
      ))}
    </div>
  );
}
